import RJELogo2 from '../../../../assets/b2b/shared/logos/RJE-logo-3.svg'
import { Box, Center, Flex, Heading, Image, useBreakpointValue, VStack } from '@chakra-ui/react'
import { Trans, useTranslation } from 'react-i18next'

export const Organisations = () => {
  const boxWidth = useBreakpointValue({ base: "95%", sm: "90%", md: "723px", lg: "933px", xl: "1127px" });
  const { t } = useTranslation();

  return (
    <Center as='section' id='organisations'>
      <Box width={boxWidth}>
        <Heading as="h2" fontSize="4xl" mb={12} color="white" textAlign={{ base: "center", md: "left" }}>
          <Trans i18nKey={"B2B.Home.Organisations.Title"}>
            placeholder <br></br>
          </Trans>
        </Heading>
        <Flex flexFlow="row wrap" justifyContent="flex-start">
          <VStack spacing={3} alignItems="flex-start" backgroundColor="#02023D" flexBasis={{ base: "100%", md: "31%" }} p={8} ml={0} mr="auto" mb={{ base: 4, md: 0 }}>
            <Image htmlHeight={90} htmlWidth={300} src={RJELogo2} alt='logo Concordium' height="3.5rem" width="auto"></Image>
            <Box color="ciphers.main.textSecondary">{t("B2B.Home.Organisations.RJE")}</Box>
          </VStack>
        </Flex>
      </Box>
    </Center >
  )
}
